import { render } from "./OfflineGame.vue?vue&type=template&id=038e02b6&scoped=true"
import script from "./OfflineGame.vue?vue&type=script&lang=js"
export * from "./OfflineGame.vue?vue&type=script&lang=js"

import "./OfflineGame.vue?vue&type=style&index=0&id=038e02b6&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038e02b6"]])

export default __exports__